"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyPolicyDiscounts = void 0;
var PropertyPolicyDiscounts;
(function (PropertyPolicyDiscounts) {
    PropertyPolicyDiscounts["ADVANCE_QUOTE"] = "Advance Quote";
    PropertyPolicyDiscounts["AFFINITY"] = "Affinity Group";
    PropertyPolicyDiscounts["BUILDING_CODE_EFFECTIVENESS_GRADING_SCHEDULE"] = "Building Code Effectiveness Grading Schedule";
    PropertyPolicyDiscounts["BURGLAR_ALARMS"] = "Burglar Alarms";
    PropertyPolicyDiscounts["FIRE_ALARMS"] = "Fire Alarms";
    PropertyPolicyDiscounts["FIRE_EXTINGUISHER"] = "Fire Extinguisher";
    PropertyPolicyDiscounts["LOSS_FREE"] = "Loss Free";
    PropertyPolicyDiscounts["GOOD_PAYER"] = "Good Payer";
    PropertyPolicyDiscounts["NO_CLAIMS"] = "No Claims";
    PropertyPolicyDiscounts["THEFT_PROTECTION"] = "Theft Protection";
    PropertyPolicyDiscounts["NON_SMOKER"] = "Non Smoker";
    PropertyPolicyDiscounts["RECENT_HOME_BUYER"] = "Recent Home Buyer";
    PropertyPolicyDiscounts["NEW_ROOF"] = "New Roof";
    PropertyPolicyDiscounts["NEW_HOME"] = "New Home";
})(PropertyPolicyDiscounts = exports.PropertyPolicyDiscounts || (exports.PropertyPolicyDiscounts = {}));
